Wee.fn.make('nav', {
	init: function() {
		this.$private.initScreens();
	}
}, {
	overNav: false,
	menuTimer: false,
	navShowing: false,
	initScreens: function() {
		var scope = this;

		Wee.screen.map([
			{
				max: 3,
				callback: function() {
					scope.prepMobile();
				}
			}, {
				min: 4,
				callback: function() {
					scope.prepDesktop();
				}
			}
		]);
	},
	prepDesktop: function() {
		var scope = this;

		Ps.destroy($('.nav-menu')[0]);
		$('.nav-menu').hide();
		$('.nav-menu__container--child').hide()
			.addClass('-is-tucked')
			.removeClass('-is-showing');
		$($._body).removeClass('-menu-showing');
		Wee.events.off(false, '.mobileNav');

		scope.prepDesktopEvents();

		setTimeout(function() {
			$('.nav-menu').show();
			$('.nav-menu').scrollTop(0);

			scope.sizeMenuItems(true);
		}, 1);
	},
	prepMobile: function() {
		$('.nav-menu__container--child').css('max-height', 'none')
			.show();
		$($._body).removeClass('-menu-showing');
		Wee.events.off(false, '.desktopNav');

		this.sizeMenuItems(false);

		$('.nav-menu').hide();

		setTimeout(function() {
			$('.nav-menu').show();
		}, 1);

		this.prepMobileEvents();
	},
	prepDesktopEvents: function() {
		var scope = this;

		Wee.events.on({
			'ref:siteNav': {
				'mouseenter': function() {
					scope.overNav = true;
				},
				'mouseleave': function() {
					scope.overNav = false;

					scope.hideNavMenu(false, false);
				},
				'click': function() {
					scope.hideNavMenu(false, true);
				}
			},
			'ref:navTrigger': {
				'mouseenter': function(e, el) {
					var $el = $(el);

					clearTimeout(scope.menuTimer);
					scope.navShowing = $el;

					setTimeout(function() {
						scope.hideNavMenu(false, true);

						if (scope.overNav && scope.navShowing === $el) {
							setTimeout(function() {
								scope.showNavMenu($el);
							}, 0);
						}
					}, 200);
				},
				'mouseleave': function(e, el) {
					scope.navShowing = false;

					scope.hideNavMenu($(el));
				}
			}
		}, {
			namespace: 'desktopNav'
		});
	},
	prepMobileEvents: function() {
		Wee.events.on({
			'.header__triggers-mobile-nav': {
				'click': function() {
					var $body = $($._body);
					$body.toggleClass('-menu-showing');

					if ($body.hasClass('-menu-showing')) {
						$('.nav-menu').scrollTop(0);
						Ps.initialize($('.nav-menu')[0]);
					} else {
						Ps.destroy($('.nav-menu')[0]);
					}
				}
			},
			'main': {
				'click': function() {
					var $body = $($._body);

					if ($body.hasClass('-menu-showing')) {
						$body.removeClass('-menu-showing');

						if ($body.hasClass('-menu-showing')) {
							$('.nav-menu').scrollTop(0);
							Ps.initialize($('.nav-menu')[0]);
						} else {
							Ps.destroy($('.nav-menu')[0]);
						}
					}
				}
			},
			'window': {
				'scroll': function() {
					var $body = $($._body);

					if ($body.hasClass('-menu-showing')) {
						$body.removeClass('-menu-showing');
						Ps.destroy($('.nav-menu')[0]);
					}
				}
			}
		}, {
			namespace: 'mobileNav'
		});
	},
	showNavMenu: function($menu) {
		$menu.addClass('-is-showing');
		$('ref:siteNav').addClass('-menu-showing');
		$('.nav-menu__container--child', $menu).removeClass('-is-tucked');
	},
	hideNavMenu: function($menu, immediate) {
		var scope = this,
			$els;

		if ($menu) {
			$els = $('.nav-menu__container--child', $menu);
		} else {
			$els = $('.-is-showing .nav-menu__container--child', 'ref:siteNav');
		}

		if (immediate) {
			scope.doHideNav($els, true);
		} else {
			setTimeout(function() {
				scope.doHideNav($els);
			}, 500);
		}
	},
	doHideNav: function($els, immediate) {
		if (! this.overNav || immediate) {
			$els.addClass('-is-tucked');
			$('ref:siteNav').removeClass('-menu-showing');

			$els.each(function(el) {
				$(el).closest('.nav-menu__item--parent').removeClass('-is-showing');
			});
		}
	},
	sizeMenuItems: function(forDesktop) {
		this.sizeParents(forDesktop);
	},
	sizeParents: function(forDesktop) {
		var scope = this;

		$('.nav-menu__item--parent').each(function(nav) {
			var $nav = $(nav);

			$nav.css('width', 'auto');

			if (forDesktop) {
				setTimeout(function() {
					$nav.css('width', ($nav.width() + 1) + 'px');
				}, 0);
			}
		});

		setTimeout(function() {
			scope.sizeChildren();
		}, 10);
	},
	sizeChildren: function() {
		$('.nav-menu__container--child').each(function(el) {
			(function($el) {
				$el.addClass('-js-sizing')
					.css('max-height', 'none');

				setTimeout(function() {
					$el.removeClass('-is-tucked');
				}, 0);

				setTimeout(function() {
					$el.show();
				}, 1);

				setTimeout(function() {
					$el.css('max-height', $el.height() + 'px')
						.addClass('-is-tucked')
						.removeClass('-js-sizing');
				}, 2);
			})($(el));
		});
	}
});
